var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DateConverter } from "./../../../../converters/DateConverter";
import { VatRegistrationStatusChange } from "./VatRegistrationStatusChange";
export class PoaRevokedStatusChange extends VatRegistrationStatusChange {
  constructor(_data) {
    super();
    /**
     */
    __publicField(this, "DateOfRevocation");
    /**
     */
    __publicField(this, "PoaRevocationConfirmationDocumentId");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof PoaRevokedStatusChange
     */
    __publicField(this, "$type", "V1.Companies.VatRegistrations.PoaRevokedStatusChange");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    super.init(_data);
    if (_data) {
      this.DateOfRevocation = DateConverter.from(_data["DateOfRevocation"]);
      this.PoaRevocationConfirmationDocumentId = _data["PoaRevocationConfirmationDocumentId"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    super.toJSON(_data);
    _data["DateOfRevocation"] = DateConverter.toUtcDateString(this.DateOfRevocation);
    _data["PoaRevocationConfirmationDocumentId"] = this.PoaRevocationConfirmationDocumentId;
    return _data;
  }
}
